import * as tslib_1 from "tslib";
import * as React from "react";
var PassThrought = function (_a) {
    var children = _a.children;
    return children;
};
var MediaServerSide = (function (_super) {
    tslib_1.__extends(MediaServerSide, _super);
    function MediaServerSide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            key: 'media-as-predicted'
        };
        return _this;
    }
    MediaServerSide.prototype.componentDidMount = function () {
        var _a = this.props, fact = _a.fact, predicted = _a.predicted, hydrated = _a.hydrated;
        if (fact && fact !== predicted) {
            if (hydrated) {
                this.setState({
                    key: 'media-prediction-failed'
                });
            }
            console.error("React-media-match: SSR failed \"" + predicted + "\" was predicted, while \"" + fact + "\" seen by fact.");
        }
    };
    MediaServerSide.prototype.render = function () {
        return React.createElement(PassThrought, { key: this.state.key }, this.props.children);
    };
    return MediaServerSide;
}(React.Component));
export { MediaServerSide };
